import {
  AlertController,
  LoadingController,
  Loading,
  ToastController
} from 'ionic-angular';
import { Injectable } from '@angular/core';
import { ConfigService } from '../services/config.service';

@Injectable()
export class AppUtilities {
  private loader: Loading;

  public constructor(
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private configService: ConfigService
  ) {}

  public alert(text: string) {
    this.alertCtrl
      .create({
        subTitle: text,
        buttons: ['OK']
      })
      .present();
  }

  public confirm(text: string, success) {
    var cancel, confirm;
    var idioma = this.configService.getIdiom();
    if (idioma == 'en') {
      cancel = 'Cancel';
      confirm = 'Confirm';
    }
    if (idioma == 'es') {
      cancel = 'Cancelar';
      confirm = 'Confirmar';
    }

    this.alertCtrl
      .create({
        message: text,
        buttons: [
          {
            text: cancel
          },
          {
            text: confirm,
            handler: success
          }
        ]
      })
      .present();
  }

  public confirm2(text: string, success) {
    var cancel, confirm;
    var idioma = this.configService.getIdiom();
    if (idioma == 'en') {
      cancel = 'No, back';
      confirm = 'Yes, cancel';
    }
    if (idioma == 'es') {
      cancel = 'No, volver';
      confirm = 'Si, cancelar';
    }

    this.alertCtrl
      .create({
        message: text,
        buttons: [
          {
            text: cancel
          },
          {
            text: confirm,
            handler: success
          }
        ]
      })
      .present();
  }

  public loading(text: string = '') {
    this.loadingDismiss();

    this.loader = this.loadingCtrl.create({
      content: text
    });

    return this.loader.present();
  }

  public loadingDismiss() {
    if (this.loader) {
      this.loader.dismiss();
      this.loader = null;
    }
  }

  public toast(text: string) {
    let toast = this.toastCtrl.create({
      message: text,
      duration: 3000
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.utilities.ts